import axiosInstance from "../../services/API";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const joinWaitlist = createAsyncThunk(
    "waitlist/join",
    async ({ name, email, location, phone_number, interests }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("/waitlist/join/", {
                name,
                email,
                location,
                phone_number,
                interests,
            });
            return response.data;
        } catch (error) {
            const data = error.response?.data;
            // Treat duplicate (any response with a message but no fatal error) as fulfilled
            if (data?.message) {
                return { message: data.message };
            }
            return rejectWithValue(data || error.message);
        }
    }
);

const WaitlistSlice = createSlice({
    name: "waitlist",
    initialState: {
        loading: false,
        message: null,
        error: null,
    },
    reducers: {
        clearWaitlist(state) {
            state.loading = false;
            state.message = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(joinWaitlist.pending, (state) => {
                state.loading = true;
                state.message = null;
                state.error = null;
            })
            .addCase(joinWaitlist.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload.message;
                state.error = null;
            })
            .addCase(joinWaitlist.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export const { clearWaitlist } = WaitlistSlice.actions;
export default WaitlistSlice.reducer;
